var React = require('react');

function IconFile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M620.446 57.844c-7.329-7.46-17.406-11.517-27.876-11.517l-397.334 1.047c-7.198 0-13.087 5.889-13.087 13.087l-.131 25.259v796.368l.131 26.175c0 7.198 5.889 13.087 13.087 13.087h640.628c7.198 0 13.087-5.889 13.087-13.087V304.018c0-10.339-4.057-20.285-11.386-27.614L620.446 57.844zm150.243 263.057H574.64v-196.18h1.701l194.348 196.18zM260.804 842.565V124.721h235.311v234.526c0 21.725 16.621 40.047 38.346 40.047h236.228v443.27H260.804z"}));
}

IconFile.displayName = "IconFile";

IconFile.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconFile;

IconFile.default = IconFile;
